<template>
  <div class="wrap">
    <myHead></myHead>
    <div class="center">
      <div class="center-body">
        <div class="filter-panel">
          <div class="cascade-selects">
            <div style="display: flex;align-items: center;justify-content: space-between;">
              <el-button icon="el-icon-back" size="small" class="back-btn" @click="onBack">返回</el-button>
              <div style="font-size:16px;font-weight: 600;"> 星人鉴图</div>
              <el-button size="small" type="text" @click="expand_search">
                {{searchVisible?'收起':'展开'}}
                <i :class="searchVisible?'el-icon-arrow-up':'el-icon-arrow-down'"></i>
              </el-button>
            </div>
            <el-form style="margin-top: 15px;" v-if="searchVisible" ref="shearchForm" :inline="true" :model="searchParams" size="small">
              <el-form-item label="检测">
                <el-select v-model="searchParams.detection_isadd" class="w150" @change="changeDetectionIsAdd" >
                  <el-option v-for="item in Object.keys(detectionIsAdd)" :key="item" :label="detectionIsAdd[item].label"
                  :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="检测类别">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.detection_category" class="w120" clearable placeholder="全部" >
                  <el-option v-for="item in Object.keys(detectionCategory)" :key="item" :label="detectionCategory[item].label"
                  :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品标题">
                <el-input v-model="searchParams.title" clearable placeholder="请输入商品标题" size="small"/>
              </el-form-item>
              <el-form-item label="所属任务">
                <el-input :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.task_no" clearable placeholder="请输入任务编号" size="small"/>
              </el-form-item>
              <el-form-item label="检测状态">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.status" class="w120" clearable placeholder="全部">
                  <el-option  v-for="key in Object.keys(filterConfig.status_filter||{})" :key="key"
                            :label="filterConfig.status_filter[key]"
                            :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="检测方向">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.detection_direction" class="w120" clearable placeholder="全部">
                  <el-option v-for="key in Object.keys(filterConfig.detection_direction_filter||{})" :key="key"
                            :label="filterConfig.detection_direction_filter[key]"
                            :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="检测类型">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.detection_type" class="w120" clearable placeholder="全部">
                  <el-option v-for="key in Object.keys(filterConfig.detection_type_filter||{})" :key="key"
                            :label="filterConfig.detection_type_filter[key]"
                            :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="检测范围">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.detection_scope" class="w120" clearable placeholder="全部"
                          @change="changeScope">
                  <el-option v-for="key in Object.keys(filterConfig.detection_scope_filter||{})" :key="key"
                            :label="filterConfig.detection_scope_filter[key]"
                            :value="key"></el-option>
                </el-select>
              </el-form-item>
              <template v-if="searchParams.detection_scope==2 && searchParams.detection_isadd === 1">
                <el-form-item v-for="item in scopeList" :key="item.key" :label="item.label">
                  <el-select v-model="searchParams[item.key]" clearable placeholder="全部" style="width: 100px">
                    <el-option v-for="key in Object.keys(filterConfig[item.key_f+'_filter']||{})" :key="key"
                              :label="filterConfig[item.key_f+'_filter'][key]"
                              :value="key"></el-option>
                  </el-select>
                </el-form-item>
              </template>
              <el-form-item label="鉴图状态">
                <el-select :disabled ="searchParams.detection_isadd == 2" v-model="searchParams.appraisal_status" class="w120" clearable placeholder="全部"
                          @change="changeScope">
                  <el-option v-for="key in Object.keys(filterConfig.appraisal_status_filter||{})" :key="key"
                            :label="filterConfig.appraisal_status_filter[key]"
                            :value="key"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="分组">
                <el-select v-model="searchParams.group_id" class="w220" multiple clearable placeholder="全部" >
                  <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="sku替换状态">
                <el-select v-model="searchParams.sku_status" class="w120" clearable placeholder="全部" >
                  <el-option v-for="item in Object.keys(skuStatus)" :key="item" :label="skuStatus[item].label"
                            :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="商品库状态">
                <el-select v-model="searchParams.item_status" class="w120" clearable placeholder="全部" >
                  <el-option v-for="item in Object.keys(itemStatus)" :key="item" :label="itemStatus[item].label"
                            :value="item"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="handleSearch">查询</el-button>
                <el-button plain @click="refresh">重置</el-button>
              </el-form-item>

            </el-form>
          </div>
        </div>

        <div class="content-box" :style="{height: current_style.content_box_height + 'vh'}">
          <div class="content-left">
            <div class="acea-row row-medium row-between" style="height: 32px;">
              <div>
                <el-checkbox :indeterminate="isIndeterminate" :checked="checkAll" @change="handleCheckAllChange"  :key="random">全选</el-checkbox>
                <el-button size="mini" @click="handleClearAll" style="margin-left: 4px;">清空勾选</el-button>
              </div>
              <div>
                <el-button size="mini" @click="batchDown"  :disabled="checkedList.length === 0" style="margin-right: 4px;">批量下架</el-button>
                <el-button size="mini" @click="handleBatchSetGroup" :disabled="checkedList.length === 0" style="margin-right: 4px;">批量分组</el-button>
              <el-dropdown  size="mini">
                <span class="el-dropdown-link">
                  快捷键<i class="el-icon-arrow-down el-icon--right"></i>
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item>上一件商品（w）</el-dropdown-item>
                  <el-dropdown-item>下一件商品（s）</el-dropdown-item>
                  <el-dropdown-item>未鉴图（f）</el-dropdown-item>
                  <el-dropdown-item>鉴图有违规（a）</el-dropdown-item>
                  <el-dropdown-item>鉴图无违规（d）</el-dropdown-item>
                  <el-dropdown-item>多图模式-上一张（q）</el-dropdown-item>
                  <el-dropdown-item>多图模式-下一张（e）</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
              </div>
            </div>
            <div v-loading="loading" class="goods-list" ref="goodsList">
              <div v-for="(item,index) in tableData" :key="index" class="goods-item">
                <el-checkbox v-model="item.checked" @change="handleCheckSingleChange($event,item)" style="margin-right: 4px;margin-top:32px; "></el-checkbox>
                <div :class="{'active':item.id==currentGoods.id}" class="item-info">

                  <div class="acea-row"  @click="selectGoods(item,index)">
                    <img :src="item.image" class="goods-img"/>
                    <div class="goods-info flex-1 ">
                      <div>{{ item.title }}</div>
                      <div style="margin-top: 10px;">
                        <div style="color: #0cc307;">使用算力：{{item.power_num||0}}</div>
                        <div>
                          <span>{{ filterConfig.status_filter[item.status] }}</span>
                          <span style="margin-left: 10px;color: #ff4500;">问题图片数量：{{item.abnormal_count}}</span>
                        </div>
                        <div  class="status-radio-group">
  <!--                        class="status-radio" :class="{'checked':item.appraisal_status==key}"-->
                          <el-tag  class="status-radio" size="mini" :type="item.appraisal_status==key?'warning':'info'" effect="plain" v-for="key in Object.keys(filterConfig.appraisal_status_filter||{})" :key="key"
                                  @click.stop="changeAppraisalStatus(item,key)">{{filterConfig.appraisal_status_filter[key]}}
                          </el-tag>
                        </div>
                        <div style="color: #ef4242" v-if="item.remark">{{item.remark}}</div>
                      </div>
                    </div>
                  </div>
                  <div>
                    <div v-if="item.item_product">所属分组：{{item.item_product.group?item.item_product.group.name:'未分组'}} || 鉴图类别：<el-tag v-if="item.detection_type" style="height: 18px; line-height: 18px;">{{item.detection_type == 99 ? '人工鉴图' : '星人鉴图'}}</el-tag></div>
                    <div v-else-if="item.group">所属分组：{{item.group?item.group.name:'未分组'}}</div>
                    <div v-if="item.item_product">sku替换状态：{{skuStatus[item.item_product.sku_status].label}}   ||  商品库状态 ：<el-tag style="height: 18px; line-height: 18px;">{{itemStatus[item.item_product.item_status].label}}</el-tag></div>
                    <div v-else-if="item.sku_status">sku替换状态：{{skuStatus[item.sku_status].label}}   ||  商品库状态 ：<el-tag  v-if="item.item_status" style="height: 18px; line-height: 18px;">{{itemStatus[item.item_status == '4'? 4:1].label}}</el-tag></div>
                    <div v-if="item.task_batch">所属任务：{{item.task_batch.task_no}}</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="panel-pagination">
              <el-pagination v-if="page_data.total>1" :current-page.sync="page_data.page" :page-size.sync="page_data.limit"
                             :pager-count="5" :total="page_data.total"
                             :page-sizes="[10,20,50,100]"
                             layout="total, sizes, prev, pager, next, jumper"
                             small @size-change="handleSizeChange"
                             @current-change="handleCurrentChange"/>
            </div>
          </div>
          <div v-if="currentGoods.id" v-loading="detailLoading" class="content-right">
            <div class="acea-row row-medium">
              <el-radio-group v-model="imgMode" size="small">
                <el-radio-button label="list">列表模式</el-radio-button>
                <el-radio-button label="more">多图模式</el-radio-button>
              </el-radio-group>
              <el-checkbox v-model="onlyViolation" size="small" style="margin-left: 6px;" @change="changeViolation">只看违规图</el-checkbox>
              <el-select v-model="imgSize"  placeholder="图片大小" size="small" style="margin-left: 6px;width: 150px;" >
                <el-option label="图片大小：大号" value="big"></el-option>
                <el-option label="图片大小：中号" value="medium"></el-option>
                <el-option label="图片大小：小号" value="small"></el-option>
              </el-select>
            </div>
            <div class="img-box">
              <div v-if="imgMode=='more'" class="img-box-left">
                <div class="left-img">
                  <el-image
                    :src="currentImg.origin_url"
                    :preview-src-list="previewList"
                    :class="imgSize+'-img'"
                    fit=""
                    :initial-index="previewImg_initial_index"
                    @click="handlePreview(currentImg, -1, -1)"
                  ></el-image>
                </div>
                <div style="margin-top: 10px;">
                  <el-button plain size="small" @click="handlePre">上一张（q）</el-button>
                  <el-button plain size="small" @click="handleNext">下一张（e）</el-button>
                  <el-button type="primary" plain size="small" @click="handleDelImg(currentImg,currentImgIndex)" v-if="currentImg.image_type==2||currentImg.image_type==3">删除</el-button>
                </div>
                <div v-if="currentImg.remark" style="color: red;margin-top: 20px;text-align: left;font-size: 14px;font-weight: 300;margin-left: 10px;">
                  {{ currentImg.remark }}
                </div>
              </div>
              <div class="img-box-right">
                <div v-for="(item,index) in detailInfo" :key="index">
                  <div style="font-size: 12px;margin-top: 10px;">{{ item.label }}</div>
                  <div class="img-list">
                    <div v-for="(img,sindex) in  item.list" :key="index+'_'+sindex" :class="{'more':imgMode=='more', 'img-item': searchVisible,'big-img-item' : !searchVisible}"
                         @click="selectImg(index,sindex)">
                      <el-image v-if="imgMode=='more'"
                                :class="{'active':currentImgIndex[0] == index&&currentImgIndex[1]==sindex}"
                                :src="img.origin_url"
                                :preview-src-list="previewList"
                                :initial-index="previewImg_initial_index"
                                class="img-item-img"
                                fit=""
                                @click="handlePreview(img, index, sindex)"></el-image>
                      <el-image v-else
                                :preview-src-list="previewList"
                                :src="img.origin_url"
                                :initial-index="previewImg_initial_index"
                                class="img-item-img"
                                fit=""
                                @click="handlePreview(img, index, sindex)"></el-image>
                      <template v-if="imgMode=='list'">
                      <i v-if="(img.image_type==2||img.image_type==3)" class="el-icon-delete-solid del-btn"
                         @click="handleDelImg(img,[index,sindex])"></i>
                      <div style="color: #ef4242;font-size: 12px;word-break: break-word;" v-if="img.remark">{{img.remark}}</div>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- 批量加入分组弹窗 -->
      <el-dialog title="设置分组" :visible.sync="batchGroupShow" width="400px">
        <el-form label-width="80px">
          <el-form-item label="选择分组">
            <el-select v-model="batchGroupId" placeholder="请选择分组" style="width: 100%;" clearable @change="changeBatchGroupId">
              <el-option label="不加入分组" :value="0"></el-option>
              <el-option v-for="group in groupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
            <div style="color: #999; font-size: 12px; margin-top: 5px;">选择"不加入分组"将去除商品的当前分组</div>
          </el-form-item>
          <el-form-item label="选择子分组">
            <el-select v-model="batchChildGroupId" :placeholder="batchGroupId ? '请选择子分组' : '不加入分组'" style="width: 100%;" clearable :disabled="!batchGroupId">
              <el-option v-for="group in batchChildGroupList" :key="group.id" :label="group.name" :value="group.id"></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <template #footer>
          <el-button @click="batchGroupShow = false">取消</el-button>
          <el-button type="primary" @click="submitBatchSetGroup" :loading="batchGroupLoading">确定</el-button>
        </template>
      </el-dialog>
    </div>
    <myFoot></myFoot>
  </div>
</template>
<script>
import {mapActions} from "vuex";
import myHead from "@/components/myHead/myhead.vue";
import myFoot from "@/components/myFoot/myfoot.vue";
import { forEach } from "jszip";

export default {
  components: {  myHead,myFoot},
  data() {
    return {
      currentGoods: {},
      currentGoodsIndex:-1,
      imgMode: 'list',
      searchVisible: true,
      currentImgIndex: [0, 0],
      loading: false,
      searchParams: {
        status: "",
        title: "",
        task_no:"",
        detection_type: "",
        detection_scope: "",
        include_cover: "",
        include_main: "",
        include_detail: "",
        include_sku: "",
        detection_direction: "",
        appraisal_status:"",
        sku_status:"",
        group_id:"",
        item_status:"1",
        detection_category: "",
        detection_isadd: "1"
      },
      tableData: [],
      page_data: {
        limit: 50,
        page: 1,
        total: 0,
      },
      lastPage:0,
      filterConfig: {},
      scopeList: [
        {label: '检测首图', key: 'include_cover', key_f: 'cover'},
        {label: '检测主图', key: 'include_mian', key_f: 'main'},
        {label: '检测详情图', key: 'include_detail', key_f: 'detail'},
        {label: '检测Sku图', key: 'include_sku', key_f: 'sku'},
      ],
      skuStatus:{
        1:{label:'未替换', type: 'info'},
        2:{label:'已替换', type: 'success'},
        3:{label:'找不到', type: 'error'}
      },
      itemStatus:{
        1:{label:'成功', type: 'success'},
        4:{label:'手动下架', type: 'error'}
      },
      detectionCategory:{
        1:{label:'星人鉴图', type: 'success'},
        2:{label:'人工鉴图', type: 'error'}
      },
      detectionIsAdd:{
        1:{label:'已加星人鉴图', type: 'success'},
        2:{label:'未加星人鉴图', type: 'error'}
      },
      groupList:[],
      detailLoading: false,
      detailInfo: {},
      oldImgList:[],
      imageTypeFilter:{},
      imgList: [],
      imgSize:'medium',
      onlyViolation:false,//只看违规
      processedImages: {}, // 存储处理后的带框图片
      previewList: ['https://test.xinghaohuo.com/assets/img/head_logo.3c96cba5.png'], // 预览图片列表
      previewImg_initial_index: 1, //预览图片坐标
      current_style:{
        content_box_height:65
      },

      checkedList:[],
      isIndeterminate:false,
      random:Math.random(),
      batchGroupShow: false,
      batchGroupId: '',
      batchChildGroupId: '',
      batchChildGroupList: [],
      batchGroupLoading: false
    }
  },
  computed:{
    currentImg(){
      if(!this.detailInfo.length) return {}

      return this.detailInfo[this.currentImgIndex[0]].list[this.currentImgIndex[1]]
    },
    checkAll(){
      const that =this
      const checkedCount = this.tableData.filter(i => i.checked).length
      const flag = checkedCount > 0 && checkedCount === this.tableData.length
      that.isIndeterminate = checkedCount > 0 && checkedCount < this.tableData.length;
      that.random = Math.random()
      return flag
    },
  },
  watch:{

  },
  mounted() {
    window.addEventListener('keydown', this.handleKeydown);
    this.searchParams.task_no = this.$route.query.task_no
    if(this.searchParams.task_no){
      this.handleSearch()
    }else{
      this.refresh()
    }
    this.getGroupList()
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.handleKeydown);
  },
  methods: {
    ...mapActions({
      getAlienDetectionList: 'ucenter/getAlienDetectionList',
      getAlienDetectionDetail: 'ucenter/getAlienDetectionDetail',
      OpAlienDetectionDel: 'ucenter/OpAlienDetectionDel',
      opUpdateAppraisalStatus: 'ucenter/opUpdateAppraisalStatus',
      getCloudProductGroups: 'ucenter/getCloudProductGroups',
      opAlienBatchOperation: 'ucenter/opAlienBatchOperation',
      opCloudProductBatchSetGroup: 'ucenter/opCloudProductBatchSetGroup',
    }),


    onBack(){
      this.$router.back()
    },
    // 获取分组列表
    getGroupList() {
      this.getCloudProductGroups({
        data: { with_count: 0 },
        success: (res) => {
          if (res.code === 200) {
            this.groupList = res.data || []
          }
        }
      })
    },
    // === 商品列表 ===
    refresh() {
      this.page_data.page = 1
      this.page_data.total = 0
      this.tableData = []
      const detection_isadd = this.searchParams.detection_isadd
      this.searchParams = {
        item_status: "1",
        detection_isadd: "1"
      }
      this.searchParams.detection_isadd = detection_isadd

      this.$nextTick(() => {
        this.$refs.shearchForm.resetFields()
      })
      this.getDataList()
    },
    handleSearch() {
      this.page_data.page = 1
      this.tableData = []
      this.getDataList()
    },
    getDataList(index) {
      this.currentGoodsIndex=-1
      this.loading = true
      this.tableData = []
      let param = {page_size: this.page_data.limit, page: this.page_data.page, ...this.searchParams}
      this.getAlienDetectionList({
        data: param,
        success: (res) => {
          this.loading = false
          if (res.code == 200) {
            this.tableData = res.data.list.map(i=>{
              i.checked = this.checkedList.includes(i.id)
              return i
            })
            this.page_data.total = res.data.total
            this.lastPage = Math.ceil(this.page_data.total / this.page_data.limit)
            this.filterConfig = {...res.data}
            delete this.filterConfig.list
            if(!this.tableData.length){
              this.currentGoods={}
            }
            if(index||index===0){
              this.selectGoods(this.tableData[index],index)
              if(index===0){
                this.$refs.goodsList.scrollTop=0
              }else{
                this.$refs.goodsList.scrollTop=this.$refs.goodsList.scrollHeight
              }
            }

          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    handleSizeChange(val) {
      this.page_data.limit = val
      this.page_data.page = 1
      this.getDataList()
    },
    handleCurrentChange(val) {
      this.page_data.page = val
      this.getDataList()
    },
    changeScope() {
      this.scopeList.forEach(item => {
        this.searchParams[item.key] = ""
      })
    },
    //选中商品
    selectGoods(item,index) {
      this.currentGoodsIndex = index
      this.currentGoods = {...item}
      this.detailLoading = true
      let product_id = ''
      let item_id = ''
      if (item.tmp_id){
        item_id = item.tmp_id
      }
      if(item.item_product){
        product_id = item.item_product.product_id
        item_id = item.id
      } else {
        product_id = item.product_id
      }
      this.getAlienDetectionDetail({
        data: {item_id: item_id, product_id: product_id},
        success: (res) => {
          this.detailLoading = false
          if (res.code == 200) {
            let {list, image_type_filter, itemId} = res.data
            this.oldImgList = list
            this.imageTypeFilter = image_type_filter
            item.tmp_id = itemId
           this.changeViolation(image_type_filter)
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    changeViolation(){
      let image_type_filter = this.imageTypeFilter
      let list =this.oldImgList
      if(this.onlyViolation){
        list= this.oldImgList.filter(item => {
          return item.status === 3
        })
      }
      let newData = {}
      this.imgList = []
      list.forEach(item => {
        if (!newData[item.image_type]) {
          newData[item.image_type] = {
            label: image_type_filter[item.image_type],
            list: []
          }
        }
        this.imgList.push(item.origin_url)
        newData[item.image_type].list.push(item)
      })
      this.detailInfo = Object.keys(newData).map(item => {
        return newData[item]
      })
      this.selectImg(0, 0)
      // 清空缓存，重新处理图片
      this.processedImages = {}
    },

    changeAppraisalStatus(item,status){
      this.opUpdateAppraisalStatus({
        data: {
          id: item.tmp_id,
          appraisal_status: status
        },
        success: (res) => {
          if (res.code == 200) {
            item.appraisal_status = status
            this.$message.success('操作成功')
            // this.refresh()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },

    // === 快捷键 ===
    handleKeydown(event) {
      if (event.key === 'q'||event.key === 'Q') {
        this.handlePre()
      }else if (event.key === 'e'||event.key === 'E') {
        this.handleNext()
      }else if(event.key === 'w'||event.key === 'W'){
        this.handlePreGoods()
      }else if(event.key === 's'||event.key === 'S'){
        this.handleNextGoods()
      }else if(['f','a','d','F','A','D'].includes(event.key)){
        let status = event.key === 'f'||event.key === 'F'?1:event.key === 'a'||event.key === 'A'?2:3
        this.changeAppraisalStatus(this.tableData[this.currentGoodsIndex],status)
      }
    },
    //上一件商品
    handlePreGoods(){
      if(this.currentGoodsIndex==0){
        this.$message.warning('已是当前页面第一条数据了')
        return false
      }else if(this.currentGoodsIndex<0) {
        this.currentGoodsIndex=0
      } else{
        this.currentGoodsIndex--
      }
      this.selectGoods(this.tableData[this.currentGoodsIndex],this.currentGoodsIndex)
    },
    //下一件商品
    handleNextGoods(){
      if(this.currentGoodsIndex==this.tableData.length-1){
        this.$message.warning('已是当前页面最后一条数据了')
        return false
      }else if(this.currentGoodsIndex<0) {
        this.currentGoodsIndex=0
      } else{
        this.currentGoodsIndex++
      }
      this.selectGoods(this.tableData[this.currentGoodsIndex],this.currentGoodsIndex)
    },
    //上一张图
    handlePre() {
      let index0 = this.currentImgIndex[0]
      let index1 = this.currentImgIndex[1]
      if (index0 == 0 && index1 == 0) return
      if (index0 >= 0) {
        if (index1 == 0) {
          index0--
          index1 = this.detailInfo[index0].list.length - 1
        } else {
          index1--
        }
      }
      this.selectImg(index0, index1)
    },
    //下一张图
    handleNext() {
      let index0 = this.currentImgIndex[0]
      let index1 = this.currentImgIndex[1]
      if (index0 == this.detailInfo.length - 1 && index1 == this.detailInfo[index0].list.length - 1) return
      if (index0 < this.detailInfo.length) {
        if (index1 == this.detailInfo[index0].list.length - 1) {
          index0++
          index1 = 0
        } else {
          index1++
        }
      }
      this.selectImg(index0, index1)
    },

    selectImg(index0, index1) {
      this.currentImgIndex = [index0, index1]
    },
    // 处理预览点击事件
    handlePreview(imgData, bindex, sindex) {
      //当前商品的所有图片加入预览图片中
      this.previewList = []
      // console.log(this.detailInfo.list);
      let list = this.oldImgList
      if(this.onlyViolation){
        list = this.oldImgList.filter(item => {
          return item.status === 3
        })
      }
      list.forEach((item, index) => {
        if (item.status === 3 && item.remark_array && item.remark_array.length) {
          const processedUrl = this.getProcessedImageUrl(item, index)
          this.previewList.push(processedUrl)
        } else {
          this.previewList.push(item.origin_url)
        }
      })
      // // 寻找图片坐标
      let globalIndex = 0

      // 累加【当前点击父级之前所有组】的图片总数
      for (let i = 0; i < bindex; i++) {
        globalIndex += this.detailInfo[i].list.length
      }

      // // 再加上当前组内的 sindex
      globalIndex += sindex
      // console.log(globalIndex);

      this.previewImg_initial_index = globalIndex
      // if (sindex > 0) {
      //   // 只在点击时才处理图片
      //   if (imgData.status === 3 && imgData.remark_array && imgData.remark_array.length) {
      //     const processedUrl = this.getProcessedImageUrl(imgData)
      //     this.previewList = [processedUrl]
      //   } else {
      //     this.previewList = [imgData.origin_url]
      //   }
      //   previewImg_initial_index = sindex
      // }


    },
    // 获取处理后的图片URL（带框和文字）
    getProcessedImageUrl(imgData, index) {
      if (!imgData || !imgData.origin_url) return ''

      // 如果不是status=3或没有remark_array，直接返回原图
      if (imgData.status !== 3 || !imgData.remark_array || !imgData.remark_array.length) {
        return imgData.origin_url
      }

      // 如果已经处理过，直接返回缓存的URL
      const cacheKey = imgData.image_id || imgData.origin_url
      if (this.processedImages[cacheKey]) {
        return this.processedImages[cacheKey]
      }

      // 同步处理图片（因为是点击时才调用，可以同步处理）
      this.processImageSync(imgData, index)

      // 返回原图作为占位
      return imgData.origin_url
    },
    // 生成随机颜色
    getRandomColor() {
      const colors = [
        '#FF6B6B', // 红色
        '#4ECDC4', // 青色
        '#45B7D1', // 蓝色
        '#FFA07A', // 橙色
        '#98D8C8', // 薄荷绿
        '#F7DC6F', // 黄色
        '#BB8FCE', // 紫色
        '#85C1E2', // 天蓝
        '#F8B739', // 金色
        '#52B788', // 绿色
        '#E74C3C', // 深红
        '#3498DB', // 宝蓝
        '#9B59B6', // 紫罗兰
        '#1ABC9C', // 青绿
        '#F39C12', // 橙黄
        '#E67E22', // 胡萝卜橙
        '#16A085', // 深青
        '#27AE60', // 翠绿
        '#2980B9', // 深蓝
        '#8E44AD', // 深紫
        '#C0392B', // 砖红
        '#D35400', // 南瓜橙
        '#2ECC71', // 翡翠绿
        '#F1C40F', // 向日葵黄
        '#E91E63', // 粉红
        '#00BCD4', // 青蓝
        '#FF9800', // 琥珀
        '#795548', // 棕色
        '#607D8B', // 蓝灰
        '#009688', // 蒂芙尼蓝
      ]
      return colors[Math.floor(Math.random() * colors.length)]
    },
    // 检查矩形是否重叠
    isRectOverlap(rect1, rect2, padding = 5) {
      return !(rect1.right + padding < rect2.left ||
               rect1.left - padding > rect2.right ||
               rect1.bottom + padding < rect2.top ||
               rect1.top - padding > rect2.bottom)
    },
    // 查找合适的文字位置
    findTextPosition(points, textWidth, textHeight, imgWidth, imgHeight, occupiedAreas) {
      const minY = Math.min(points[0][1], points[1][1], points[2][1], points[3][1])
      const maxY = Math.max(points[0][1], points[1][1], points[2][1], points[3][1])
      const minX = Math.min(points[0][0], points[1][0], points[2][0], points[3][0])
      const maxX = Math.max(points[0][0], points[1][0], points[2][0], points[3][0])
      const centerX = (points[0][0] + points[1][0] + points[2][0] + points[3][0]) / 4
      const centerY = (minY + maxY) / 2

      const padding = 10

      // 多层候选位置列表（从近到远）
      const distanceLevels = [10, 20, 40, 60, 80, 100] // 不同的距离级别
      const candidates = []

      // 为每个距离级别生成候选位置
      distanceLevels.forEach(distance => {
        candidates.push(
          // 框下方居中
          { x: centerX - textWidth / 2, y: maxY + distance + textHeight, priority: 1 },
          // 框上方居中
          { x: centerX - textWidth / 2, y: minY - distance, priority: 2 },
          // 框右侧中间
          { x: maxX + distance, y: centerY, priority: 3 },
          // 框左侧中间
          { x: minX - textWidth - distance, y: centerY, priority: 4 },
          // 框右下角
          { x: maxX + distance, y: maxY + distance + textHeight, priority: 5 },
          // 框左下角
          { x: minX - textWidth - distance, y: maxY + distance + textHeight, priority: 6 },
          // 框右上角
          { x: maxX + distance, y: minY - distance, priority: 7 },
          // 框左上角
          { x: minX - textWidth - distance, y: minY - distance, priority: 8 }
        )
      })

      // 框内位置（最后的备选）
      candidates.push(
        { x: centerX - textWidth / 2, y: maxY - 5, priority: 9 },
        { x: centerX - textWidth / 2, y: minY + textHeight + 5, priority: 10 }
      )

      // 遍历候选位置，找到第一个不重叠的位置
      for (let pos of candidates) {
        let x = pos.x
        let y = pos.y

        // 边界检查
        if (x < padding) x = padding
        if (x + textWidth > imgWidth - padding) x = imgWidth - padding - textWidth
        if (y < textHeight + padding) y = textHeight + padding
        if (y > imgHeight - padding) continue // 跳过超出底部的位置

        // 如果调整后的x坐标无效，跳过
        if (x < padding || x + textWidth > imgWidth - padding) continue

        // 创建当前文字区域
        const textRect = {
          left: x,
          top: y - textHeight,
          right: x + textWidth,
          bottom: y
        }

        // 检查是否与已占用区域重叠
        let hasOverlap = false
        for (let area of occupiedAreas) {
          if (this.isRectOverlap(textRect, area, 5)) { // 增加5px的安全边距
            hasOverlap = true
            break
          }
        }

        if (!hasOverlap) {
          return { x, y, rect: textRect }
        }
      }

      // 如果所有位置都重叠，尝试在图片的空白区域放置
      // 将图片分成网格，找到第一个空白区域
      const gridSize = 50
      const cols = Math.floor(imgWidth / gridSize)
      const rows = Math.floor(imgHeight / gridSize)

      for (let row = 0; row < rows; row++) {
        for (let col = 0; col < cols; col++) {
          const x = col * gridSize + padding
          const y = row * gridSize + textHeight + padding

          if (x + textWidth > imgWidth - padding || y > imgHeight - padding) continue

          const textRect = {
            left: x,
            top: y - textHeight,
            right: x + textWidth,
            bottom: y
          }

          let hasOverlap = false
          for (let area of occupiedAreas) {
            if (this.isRectOverlap(textRect, area, 5)) {
              hasOverlap = true
              break
            }
          }

          if (!hasOverlap) {
            return { x, y, rect: textRect }
          }
        }
      }

      // 最后的兜底方案：放在图片右下角
      let x = imgWidth - textWidth - padding
      let y = imgHeight - padding
      if (x < padding) x = padding

      return {
        x,
        y,
        rect: { left: x, top: y - textHeight, right: x + textWidth, bottom: y }
      }
    },
    processImageSync(imgData, index) {
      const cacheKey = imgData.image_id || imgData.origin_url

      // 创建图片对象
      const img = new Image()
      img.crossOrigin = 'anonymous' // 处理跨域问题

      img.onload = () => {
        // 创建canvas
        const canvas = document.createElement('canvas')
        canvas.width = img.naturalWidth
        canvas.height = img.naturalHeight
        const ctx = canvas.getContext('2d')

        // 绘制原图
        ctx.drawImage(img, 0, 0)

        // 存储已占用的区域（框和文字）
        const occupiedAreas = []

        // 绘制框和文字
        imgData.remark_array.forEach((item, index) => {
          if (item.box && Array.isArray(item.box) && item.box.length === 4) {
            const points = item.box

            // 确定颜色：第一个框蓝色，其他随机颜色
            const color = index === 0 ? '#0066ff' : this.getRandomColor()

            // 计算框的边界并添加到占用区域
            const minX = Math.min(points[0][0], points[1][0], points[2][0], points[3][0])
            const maxX = Math.max(points[0][0], points[1][0], points[2][0], points[3][0])
            const minY = Math.min(points[0][1], points[1][1], points[2][1], points[3][1])
            const maxY = Math.max(points[0][1], points[1][1], points[2][1], points[3][1])

            occupiedAreas.push({
              left: minX,
              top: minY,
              right: maxX,
              bottom: maxY
            })

            // 绘制四边形框
            ctx.strokeStyle = color
            ctx.lineWidth = Math.max(3, img.naturalWidth / 400)
            ctx.beginPath()
            ctx.moveTo(points[0][0], points[0][1])
            ctx.lineTo(points[1][0], points[1][1])
            ctx.lineTo(points[2][0], points[2][1])
            ctx.lineTo(points[3][0], points[3][1])
            ctx.closePath()
            ctx.stroke()

            // 绘制文字标注
            if (item.remark) {
              // 设置文字样式
              // const fontSize = Math.max(14, img.naturalWidth / 50)
              const fontSize = 14
              ctx.font = `bold ${fontSize}px Arial`

              // 测量文字宽度
              const textMetrics = ctx.measureText(item.remark)
              const textWidth = textMetrics.width
              const textHeight = fontSize

              // 查找合适的文字位置（避开已有的框和文字）
              const textPos = this.findTextPosition(
                points,
                textWidth,
                textHeight,
                img.naturalWidth,
                img.naturalHeight,
                occupiedAreas
              )

              // 将文字区域添加到占用区域
              occupiedAreas.push(textPos.rect)

              // 绘制文字描边（白色，增强可读性）
              ctx.strokeStyle = '#ffffff'
              ctx.lineWidth = 5
              ctx.strokeText(item.remark, textPos.x, textPos.y)

              // 绘制文字（使用与框相同的颜色）
              ctx.fillStyle = color
              ctx.fillText(item.remark, textPos.x, textPos.y)
            }
          }
        })

        // 将canvas转换为图片URL
        const processedUrl = canvas.toDataURL('image/png')
        this.$set(this.processedImages, cacheKey, processedUrl)

        // 更新预览列表
        this.previewList[index] = processedUrl
      }

      img.onerror = () => {
        console.error('图片加载失败:', imgData.origin_url)
        // 加载失败时使用原图
        this.$set(this.processedImages, cacheKey, imgData.origin_url)
        this.previewList = [imgData.origin_url]
      }

      img.src = imgData.origin_url
    },
    handleDelImg(val,index) {
      this.$confirm("确定要删除图片吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(() => {
        this.OpAlienDetectionDel({
          data: {item_id: val.item_id, image_id: val.image_id, product_id: val.product_id},
          success: (res) => {
            if (res.code == 200) {
              this.detailInfo[index[0]].list.splice(index[1],1)
              this.$message.success('删除成功')
              this.selectGoods(this.currentGoods,this.currentGoodsIndex)
            } else {
              this.$message.error(res.message)
            }
          }
        })
      })
    },
    expand_search() {
      this.searchVisible = !this.searchVisible
      if (this.searchVisible) {
        this.current_style.content_box_height = 65
        this.imgSize = 'medium'
      } else {
        this.current_style.content_box_height = 75
        this.imgSize = 'big'
      }
    },

    // === 批量下架 ===
    handleCheckAllChange(val) {
      this.tableData.forEach(i=>{
        i.checked = val
      })
      const allArr = this.tableData.map(i => {
        if(i.item_product) {
          return i.item_product.id
        } else {
          return i.id
        }

      })

      this.checkedList = val ? [...new Set([...this.checkedList, ...allArr])] : this.checkedList.filter(i => !allArr.includes(i));
    },
    handleCheckSingleChange(e,row) {
      let check_id = ''
       if(row.item_product) {
          check_id = row.item_product.id
        } else {
          check_id = row.id
        }
      if (!e) {
        this.checkedList = this.checkedList.filter(i => i !== check_id)
      } else {
        this.checkedList.push(check_id)
      }

    },
    handleClearAll(){
      this.checkedList=[]
      this.tableData.forEach(i=>{
        i.checked = false
      })
    },
    batchDown(){
      if( !this.checkedList.length){
        this.$message.warning('请选择要下架的商品')
        return false
      }
      this.$confirm(`确定要下架【${this.checkedList.length}】个商品吗？`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.opAlienBatchOperation({
          data: {
            ids: this.checkedList.join(','),
            type: 1,
          },
          success: (res) => {
            if (res.code === 200) {
              this.$message.success('下架成功')
              this.handleClearAll()
              this.handleSearch()
            }
          }
        })
      })
    },
     // 批量加入分组
    handleBatchSetGroup() {
      if (this.checkedList.length === 0) {
        this.$message.warning('请先选择商品')
        return
      }
      this.batchGroupId = null
      this.batchChildGroupId = null
      this.batchChildGroupList = []
      this.batchGroupShow = true
    },
    // 提交批量加入分组
    submitBatchSetGroup() {
      if (this.batchGroupId === null || this.batchGroupId === '') {
        this.$message.warning('请选择分组')
        return
      }
      this.batchGroupLoading = true
      const product_ids = this.checkedList
      const isRemoveGroup = this.batchGroupId === 0
      if (!isRemoveGroup && !this.batchChildGroupId) {
        this.$message.warning('请选择子分组')
        this.batchGroupLoading = false
        return
      }
      this.opCloudProductBatchSetGroup({
        data: { product_ids, child_group_id: isRemoveGroup ? null : this.batchChildGroupId },
        success: (res) => {
          this.batchGroupLoading = false
          if (res.code === 200) {
            this.batchGroupShow = false
            this.$message.success(isRemoveGroup ? '已去除分组' : '加入分组成功')
            this.handleClearAll()
            this.handleSearch()
          } else {
            this.$message.error(res.message)
          }
        }
      })
    },
    changeBatchGroupId(groupId) {
      this.batchChildGroupId = ''
      const target = this.groupList.find(item => item.id === groupId)
      this.batchChildGroupList = target?.child_groups || []
    },
    changeDetectionIsAdd(val) {
      this.refresh()
    }


  },


}
</script>


<style lang="scss" scoped>
.center{
width: 1400px;
  max-width: 1400px;
min-height: 800px;
}
.w120 {
  width: 120px;
}
.w150 {
  width: 150px;
}
.w220 {
  width: 220px;
}
.acea-row {
  display: flex;
}
.row-medium{
  align-items: center;
}
.row-between {
  justify-content: space-between;

}

.flex-1 {
  flex: 1;
}
.center-body{
  min-height: 800px;
  position: relative;
  margin: 28px auto 40px;
  background: #fff;
  padding: 25px 40px 30px;
  width: 100%;
  overflow: hidden;
  box-sizing: border-box; /* 确保 padding 不会撑大容器宽度，防止溢出 */

  .back-btn{
    // position: absolute;
    top: 15px;
    left: 38px;
    bottom: 5px;
    width: fit-content;
  }
}

.content-box {
  display: flex;
  height:65vh;

  .content-left {
    width: 430px;
    border-right: 1px solid #EEEEEE;
    display: flex;
    flex-direction: column;
    padding-bottom: 10px;

    .goods-list {
      flex: 1;
      overflow-y: auto;

      &::-webkit-scrollbar {
        //width: 6px;
      }

      .goods-item {
        display: flex;
        //align-items: center;
        padding: 4px 0;
        border-bottom: 1px solid #EEEEEE;
        cursor: pointer;

        .item-info {
          //display: flex;
          flex: 1;
          padding: 4px;
          border-radius: 4px;
          margin-right: 4px;
          font-size: 12px;
          border: 1px solid transparent;

          &.active {
            border: 1px solid #ff4400;
          }
        }

        .goods-img {
          width: 80px;
          height: 80px;
          border-radius: 4px;
          display: block;
          margin-right: 10px;
        }

        .goods-info {
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }

        .btn {
          padding: 2px;
          line-height: 12px;
          font-size: 12px;
          /*cursor: pointer;
          &.primary{
            border: 1px solid #fcd9d8 ;
            background:#feecec;
            color: #f68d8b;
          }
          &.info{}*/
        }

        .status-radio-group{
          margin-top: 4px;
          .status-radio{
            margin-right: 8px;
            &.checked{
              color: #f3ad0a;
            }
          }
        }

      }
    }
  }

  .content-right {
    flex: 1;
    display: flex;
    flex-direction: column;

    .img-box {
      display: flex;
      flex: 1;
      overflow-y: auto;

      .img-box-left {
        width: calc(100% - 170px);
        margin: 30px 0;
        text-align: center;
        box-sizing: border-box;
        overflow-y: auto;

        //display: flex;
        //flex-direction: column;
        .left-img{
          flex: 1;
          overflow-y: auto;
        }
        .big-img {
          //width: calc(100% - 60px);
          width: 80%;
          height: auto;
        }
        .medium-img {
          //width: calc(100% - 140px);
          width: 60%;
          height: auto;
        }
        .small-img {
          //width: 240px;
          width: 40%;
          height: auto;
        }

      }

      .img-box-right {
        margin-left: 10px;
        flex: 1;
        height: 100%;
        overflow-y: auto;

        .img-list {
          display: flex;
          flex-wrap: wrap;
          gap: 6px;
          //display: grid;
          //grid-template-columns: repeat(4,1fr);
          //grid-gap: 10px;
          margin-top: 6px;

          .img-item {
            width: 80px;
            padding-bottom: 6px;
            border-bottom: 1px solid #EEEEEE;
            cursor: pointer;
            position: relative;
            box-sizing: border-box;

            .del-btn {
              position: absolute;
              top: 5px;
              right: 5px;
              color: red;
              font-size: 18px;
            }

            .img-item-img {
              width: 80px;
              height: 80px;
              display: block;
            }
            &.more {
              width: 44px;
              .img-item-img{
                width: 40px;
                height: 40px;
                border: 2px solid transparent;
                &.active {
                  border: 2px solid #ff4400;
                }
              }
            }
          }
          .big-img-item {
            width: 100px;
            padding-bottom: 6px;
            border-bottom: 1px solid #EEEEEE;
            cursor: pointer;
            position: relative;
            box-sizing: border-box;

            .del-btn {
              position: absolute;
              top: 5px;
              right: 5px;
              color: red;
              font-size: 18px;
            }

            .img-item-img {
              width: 100px;
              height: 100px;
              display: block;
            }
            &.more {
              width: 44px;
              .img-item-img{
                width: 40px;
                height: 40px;
                border: 2px solid transparent;
                &.active {
                  border: 2px solid #ff4400;
                }
              }
            }
          }

        }
      }
    }

  }
}


.panel-pagination {
  padding: 10px 0;

  :deep(.el-pagination) {
    padding: 2px 0;
    li{
      padding:0 2px;
    }
    .btn-next {
      padding-left: 0;
      padding-right: 0;
    }

    .btn-prev {
      padding-left: 0;
      padding-right: 0;

    }

    .el-pagination__jump {
      //margin-left: 6px;
      margin-left: 0;
    }
    .el-select .el-input{
      width: 80px;
      margin: 0;
    }
    .el-select .el-input .el-input__inner{
      padding-left: 2px;
      padding-right: 20px;
      line-height: 22px;
      height: 22px;
    }
    .el-input--mini .el-input__icon {
      line-height: 22px;
    }
    .el-pagination__sizes{
      margin-right: 0;
    }
  }
}

.filter-panel {
  border: 1px solid #ebeef5;
 /* background: #fafbfc;*/
  padding: 8px; /* 减少内边距 */
  margin-bottom: 8px;
  margin-top: -10px;
}

/* 二级选择器 */
.cascade-selects {
 /* display: flex;*/
  gap: 8px;
  /*margin-bottom: 8px;*/ /* 减少下边距 */
  align-items: center;
  flex-wrap: wrap;
}


</style>
